import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game } from '../../../../Core'

import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'

/**
 *  Pop up showed when the user skips the tutorial
 */
class SkipTutorialConfirmationPopup extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
  }

  removePopup() {
    const { removePopup, addHowlSound } = this.props
    addHowlSound('button_click')
    removePopup('skip_tutorial_confirmation_popup')
  }

  render() {
    return (
      <div className="popup--game">
        <div className="popup--box">
          <div className="popup--box__canvas">
            <div className="popup--text">
              <FormattedMessage id="phase.skipTutorialWarning" />
            </div>
            <div className="popup--buttons">
              <div
                onClick={() => {
                  this.removePopup()
                }}
                className="btn--shape shape--blue"
              >
                <div className="btn--shape__canvas">
                  <FormattedMessage id="phase.accept" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}

SkipTutorialConfirmationPopup.propTypes = {
  removePopup: PropTypes.func,
  addHowlSound: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(SkipTutorialConfirmationPopup))
